// src/store/thunks/user/fetchNotificationsThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

export const fetchNotificationsThunk = createAppAsyncThunk(
  "user/fetchNotifications",
  async(_, { extra: { userService } }) => await userService.getNotifications()
);
